// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5016":"3109a4cd9c163404","5672":"b0ee8c6c90216a98"}[chunkId] + ".js";
};